import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { appConfig } from "../../../../config/config";

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  private readonly nameSess: string;

  constructor(private router: Router) {
    this.nameSess = appConfig.data_session;
  }

  ngOnInit(): void {
    localStorage.removeItem(this.nameSess);
    if (sessionStorage.getItem('insuadvisor_token') === null || sessionStorage.getItem('insuadvisor_token') === 'undefined') {
      this.router.navigate(['login']).then();
    }
  }

}
